import { useEffect } from 'react';
import { createSocketConnection } from 'shared/exceptions/socketService';
import { listen } from './listenFunction';

type Options = {
  callBack: (payload: unknown) => void;
  id: string;
  isAuth: boolean;
};

export const useStateSocket = ({ id, callBack, isAuth }: Options) => {
  useEffect(() => {
    if (isAuth) {
      console.log('STATE HOOK');
      createSocketConnection();
      return listen(callBack, `mini_app.${id}`, '.mini_app');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
